import styled from 'styled-components';

export const FooterBox = styled.div`
  margin-top: 32px;
  margin-bottom: 56px;
  text-align: center;
`;
